import { HttpService } from '../shared'

export class AppConfigProvider {
  constructor(private http: HttpService) {}

  public get() {
    return this.http.get('/public/appConfig.json').then((response) => {
      if (typeof response.data === 'string') {
        JSON.parse(response.data) // it will throw
      }
      return response
    })
  }
}
